import { RouteObject } from 'react-router-dom';

import ThreeDModelSettingPage from '../../pages/project-setting/3d-model';
import Create3DModel from '../../pages/project-setting/3d-model/Create3DModel';

const threeDimensionalSettingRouter: RouteObject = {
  path: '3d-model',
  element: <ThreeDModelSettingPage />,
  children: [
    {
      path: 'create',
      element: <Create3DModel />,
    },
  ],
};

export default threeDimensionalSettingRouter;
